export const API_CONFIG = {
  BASE_URL: 'https://apiunisol.com/gsport_backend/api/v1',
  ENDPOINTS: {
    SEND_OTP: '/mtn/otp/send',
    VERIFY_OTP: '/mtn/otp/verify',
    SUBSCRIBE: '/mtn/subscribe',
  },
} as const;

export const AUTH_CONFIG = {
  COUNTRY_CODE: '268',
  PHONE_DIGIT_LENGTH: 8,
} as const;

export const getApiUrl = (endpoint: string): string =>
  `${API_CONFIG.BASE_URL}${endpoint}`;
